<template>
  <BaseModal ref="modal">
    <UiModalDialog
      class="jps-sort-modal"
      dialog-width="60vw"
      dialog-height="80vh"
    >
      <template #header>
        {{ lss('並び替え', 'Sort') }}
      </template>
      <div class="jps-modal-content">
        <Container group-name="1"
         :get-child-payload="getChildPayload"
         @drop="onDrop">
          <Draggable v-for="item in list" :key="item.sortModalKey || item">
            <slot v-bind="{ item }">
              <article class="draggable-item media">
                <BaseIcon name="mdi/drag-horizontal" />
                <div class="media-content">{{ renderer(item) }}</div>
              </article>
            </slot>
          </Draggable>
        </Container>
      </div>
      <template #buttons>
        <button @click="modal.reject()">{{ ls(dapLangGlobal.cancel) }}</button>
        <button @click="confirm()">{{ ls(dapLangGlobal.ok) }}</button>
      </template>
    </UiModalDialog>
  </BaseModal>
</template>

<script lang="ts" setup>
import { Container, Draggable } from 'vue3-smooth-dnd'
import { dapLangGlobal } from '#imports'
import type { BaseModal } from '#components'

const { ls, lss } = useI18n()
const { onDropSort } = useSort()

interface Props {
  values?: any[]
  renderer?: (value: any) => string
}
const props = withDefaults(defineProps<Props>(), {
  renderer: (value: any) => value,
})

const modal = ref<InstanceType<typeof BaseModal>>()
const openAwait = async (targetArray: any[] = null) => {
  let tmpList = []
  if (targetArray) {
    tmpList = clone(targetArray)
  } else if (props.values) {
    tmpList = clone(props.values)
  }
  tmpList.forEach(e => {
    if (typeof e === 'object') {
      e.sortModalKey = luId()
    }
  })
  list.value = tmpList
  return await modal.value.openAwait<any[]>()
}
defineExpose({ openAwait })

const list: Ref<any[]> = ref([])

const onDrop = (dropResult) => {
  list.value = onDropSort(dropResult, list.value)
}

const getChildPayload = (index) => {
  return list.value[index]
}

const confirm = () => {
  let tmpList = clone(list.value)
  tmpList.forEach(e => delete e.sortModalKey)
  modal.value.resolve(tmpList)
}
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.jps-sort-modal {
  .draggable-item {
    border: 1px solid $border-grey;
    padding: 0.2em;
    margin-bottom: 0.1em;
    .jps-icon {
      margin-right: 0.25rem;
    }
    background: $white;
    display: flex;
    align-items: center;
    cursor: move;
  }
}
</style>
